import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import CloneConfig from './submodules/clone';
import ConfigConversions from './submodules/conversions';
import CreateConfig from './submodules/create';
import ConfigList from './submodules/list';
import EditConfig from './submodules/edit';

const CtdConfigDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getCTDConfigs]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ConfigList}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createCTDConfigs]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneConfig}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createCTDConfigs]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateConfig}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getCTDConfigs]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/conversionDetails`}
				component={ConfigConversions}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updateCTDConfigs]}
				path={`${path}/edit`}
				configPageName={PAGE_NAMES.dashboard}
				component={EditConfig}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default CtdConfigDashboard;
